import Slider from 'bee-slider'
export default Slider
